// OrtoSoft — i18n — Română
// Note: legal bodies on /ml intentionally stay in French (official document).

const ro = {
  // navigație
  'nav.home': 'OrtoSoft — acasă',
  'nav.contact': 'Contact',
  'nav.tel': 'Tel.',
  'nav.telShort': 'Tel.',
  'nav.email': 'Email',

  // hero — fața foii
  'hero.kicker': 'Portofoliu — OrtoSoft',
  'hero.oAria': 'Logo-ul O al OrtoSoft, construit geometric',
  'hero.lede':
    'Software proiectat și construit drept. Trei produse, online — examinați desenele, apoi discutați cu mine despre proiectul dumneavoastră.',
  'hero.ctaDrawings': 'Vezi desenele',
  'hero.ctaContact': 'Contact',
  'note.scale': 'Scară',
  'note.author': 'Autor',
  'note.sheets': 'Foi',
  'note.year': 'An',

  // secțiuni
  'section.series': 'Serie',
  'section.drawings': 'Desenele',
  'section.drafter': 'Desenatorul',

  // desene
  'sheet.tab': 'Desen',
  'sheet.reading': 'distanța de citire',
  'dist.overview': 'Prezentare generală',
  'dist.action': 'În acțiune',
  'dist.hood': 'Detalii tehnice',
  'sheet.visit': 'Vizitează',
  'sheet.login': 'Autentificare',
  'sheet.demo': 'Vezi demonstrația',
  'sheet.get': 'Obține',
  'plate.fig': 'Fig.',

  // desen 01 — cefalometrie
  'p01.title': 'Cefalometrie',
  'p01.sub': 'Analize cefalometrice și monitorizarea pacienților — pentru cabinetul dental.',
  'p01.across':
    'Un software de analize cefalometrice și monitorizare a pacienților, gândit împreună cu cabinetele — cele 20 repere cefalometrice sunt trasate automat de IA în mai puțin de o secundă, cu urmărirea tratamentului : fotografii, go / no-go la fiecare etapă (aliniere sau brackets).',
  'p01.capTracing': 'Trasare reală',
  'p01.capDemo': 'Demo — video',
  'p01.f1k': 'Funcție',
  'p01.f1v': 'Analize cefalometrice și monitorizarea pacienților',
  'p01.f2k': 'Public țintă',
  'p01.f2v': 'Cabinete dentale și ortodontiști',
  'p01.f3k': 'Produs',
  'p01.f3v': 'ortho.ortosoft.fr — online',
  'p01.f4k': 'Demonstrare',
  'p01.f4v': 'Video de prezentare (YouTube)',
  'p01.f5k': 'Trasare IA',
  'p01.f5v': 'Cele 20 repere cefalometrice sunt trasate automat în mai puțin de o secundă',
  'p01.f6k': 'Monitorizarea pacienților',
  'p01.f6v': 'Pacienții primesc un link web pentru a trimite fotografiile definite conform protocolului propriu al medicului — mai puține consultări, timp economisit',

  // desen 02 — simple bookmarks
  'p02.title': 'Simple Bookmarks',
  'p02.sub': 'Gestionar de marcaje — simplu și ecologic.',
  'p02.across': 'Îți regăsești marcajele, simplu și ecologic. Schimbă browserul fără bătăi de cap cu import/export de favorite — conectează-te de oriunde și le regăsești repede.',
  'p02.capLive': 'Online',
  'p02.f1k': 'Funcție',
  'p02.f1v': 'Gestionar de marcaje pentru browser',
  'p02.f2k': 'Principiu',
  'p02.f2v': 'Simplu și ecologic — esențialul, nimic mai mult',
  'p02.f3k': 'Produs',
  'p02.f3v': 'sb.ortosoft.fr — online',

  'p03.title': 'Doctolib Pro - export agenda',
  'p03.sub': 'Extensie Chrome — agenda zilei, exportat cu un clic.',
  'p03.across': 'Contorul zilei apare pe pro.doctolib.fr; un clic exportă agenda în JSON — descărcare locală sau POST către serverul propriu al practicianului.',
  'p03.capPopup': 'Pe pagină — contorul zilei, butonul Export',
  'p03.capOptions': 'Opțiuni — adresa serverului (POST) sau descărcare locală',
  'p03.f1k': 'Funcție',
  'p03.f1v': 'Extensie Chrome pentru pro.doctolib.fr',
  'p03.f2k': 'Export',
  'p03.f2v': 'JSON — descărcare locală sau POST către serverul propriu',
  'p03.f3k': 'Produs',
  'p03.f3v': 'Chrome Web Store',

  // desenatorul
  'about.line':
    'Bogdan Scanteie — designer & dezvoltator, OrtoSoft. Deschis pentru colaborări și proiecte freelance.',
  'about.tag': 'Unghiul drept: ideea dreaptă, unealta corectă.',
  'about.write': 'Scrie',
  'about.call': 'Sune',

  // titlu-bloc (footer)
  'footer.company': 'Societate',
  'footer.contact': 'Contact',
  'footer.legal': 'Legal',
  'footer.ref': 'Ref.',
  'footer.cgv': 'CGV',
  'footer.ml': 'Mențiuni legale',

  // pagină legală
  'ml.tab': 'Fișa legală',
  'ml.title': 'Mențiuni legale',
  'ml.societe': 'Societate',
  'ml.cookies': 'Cookie-uri',
  'ml.cgv': 'Condiții generale de vânzare',
  'ml.host': 'Hosting',
};

export default ro;
